export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGOUT = 'LOGOUT';

// Modal
export const LOGIN_MODAL_SHOWN = 'LOGIN_MODAL_SHOWN';
export const SIGNUP_MODAL_SHOWN = 'SIGNUP_MODAL_SHOWN';
export const LOGIN_SIGNUP_MODAL_HIDDEN = 'LOGIN_SIGNUP_MODAL_HIDDEN';

// Location Update
export const LOCATION_UPDATE_SUCCESS = 'LOCATION_UPDATE_SUCCESS';
export const LOCATION_UPDATE_FAIL = 'LOCATION_UPDATE_FAIL';

// Notifications
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const CLEAR_ALL_NOTIFICATIONS = 'CLEAR_ALL_NOTIFICATIONS';
export const NOTIFICATIONS_FETCH_ERROR = 'NOTIFICATIONS_FETCH_ERROR';
export const NOTIFICATION_CLEAR_ERROR = 'NOTIFICATION_CLEAR_ERROR';

// Cart
export const GET_CART_ITEMS = 'GET_CART_ITEMS';
export const CLEAR_CART_ITEM = 'CLEAR_CART_ITEM';
export const CLEAR_ALL_CART_ITEMS = 'CLEAR_ALL_CART_ITEMS';
export const CART_FETCH_ERROR = 'CART_FETCH_ERROR';
